import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

import messages from './CorporateGovernanceView.intl';
import styles from './CorporateGovernanceView.module.scss';
import { observer } from 'mobx-react';

import { Container, Title } from 'common/components/Layout/Layout';
import ImageGreyBackground from 'common/components/ImageGreyBackground/ImageGreyBackground';
import Document from 'common/components/Document/Document';

import ContentStore from 'stores/Content.store';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

import Placeholder from 'common/components/Placeholder/Placeholder';
import FullWidthBackground from 'common/components/Placeholder/components/FullWidthBackground/FullWidthBackground';
import Modal from '../../common/components/Modal/Modal';

@injectIntl
@observer
export default class CorporateGovernanceView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: true
    };
  }

  toggleModal = () => {
    this.setState(prevState => ({ isModalOpen: !prevState.isModalOpen }));
  };

  render() {
    const content = ContentStore.content;
    return (
      <>
        <div className={styles.CorporateGovernance}>
          {ContentStore.isLoaded && (
            <InjectMetaTags {...content.corporateGovernanceSEO} />
          )}
          <Container>
            <Title title={this.props.intl.formatMessage(messages.heading)} />
          </Container>
          <Placeholder component={<FullWidthBackground />} ready={!!content}>
            {content && (
              <ImageGreyBackground
                className={styles.BoldHeading}
                source={content.corporateGovernanceImage}
                alternative="hello"
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: content.corporateGovernanceText
                  }}
                />
              </ImageGreyBackground>
            )}
          </Placeholder>
          {content && (
            <Container>
              <div className={styles.CorporateGovernanceContent}>
                <p>{content.corporateGovernanceFilesHeader}</p>
                {content.corporateGovernanceFiles.map(item => (
                  <Document key={item.system.id} document={item} />
                ))}
              </div>
            </Container>
          )}
        </div>
        <Modal isOpen={this.state.isModalOpen} onClose={this.toggleModal}>
          {content.modalContent}
        </Modal>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CorporateGovernance/CorporateGovernanceView.js